export enum DataStatus {
    EMPTY,
    OK,
    LOADING,
    ERROR,
};
